import { BaseDateRequest } from './base-date-request';
export class BaseSearchRequest extends BaseDateRequest {
  storeIds?: number[];
}
